'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxReviewslider } from './Reviewslider'
import { ReviewsliderProps } from './Reviewslider'

interface ReviewsliderBlokProps {
  blok: {
    title: ReviewsliderProps['title']
    subtitle: ReviewsliderProps['subtitle']
    reviews: any
    layout?: 'default' | 'row'
  } & SbBlokData
}

const Reviewslider: FC<ReviewsliderBlokProps> = ({ blok }) => {
  const [reviews, setReviews] = useState()
  useEffect(() => {
    if (blok.reviews) {
      const reviewsArray = blok.reviews.map((review: any) => {
        let rating = review?.rating ? Number(review.rating) : 0
        return {
          rating: rating,
          content: review.content
            ? review.content.map((content: any) => (
                <StoryblokServerComponent key={content._uid} blok={content} />
              ))
            : null,
          author: review.author,
        }
      })
      setReviews(reviewsArray)
    }
  }, [blok.reviews])
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxReviewslider
        title={blok.title}
        subtitle={blok.subtitle}
        reviews={reviews}
        layout={blok.layout}
      />
    </div>
  )
}

export default Reviewslider
